export enum RescheduleSlotGroupType {
	AfterLastSession = 1,
	FlexAvailability = 2,
	PlannedAvailability = 3
}

export interface IRescheduleSlot {
	date: string;
	preferenceScore: number;
	/** Database TimezoneID for the timezone this slot is scheduled in. Null if unknown. */
	timezoneId?: number;
}

export interface IRescheduleSlotGroup {
	type: RescheduleSlotGroupType;
	label: string;
	slots: IRescheduleSlot[];
}

export interface IRescheduleOptionsResponse {
	groups: IRescheduleSlotGroup[];
}
